import { render, staticRenderFns } from "./ProjectCustomRequest.vue?vue&type=template&id=268d8e0c"
import script from "./ProjectCustomRequest.vue?vue&type=script&lang=ts"
export * from "./ProjectCustomRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('268d8e0c')) {
      api.createRecord('268d8e0c', component.options)
    } else {
      api.reload('268d8e0c', component.options)
    }
    module.hot.accept("./ProjectCustomRequest.vue?vue&type=template&id=268d8e0c", function () {
      api.rerender('268d8e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectCustomRequest.vue"
export default component.exports